module.exports = __webpack_public_path__ + "img/resdetailsBan.aac4b414.png";